export const BreakpointsUpgradeEnum = {
  MobileXS: 350,
  MobileS: 475,
  XXS: 658,
  XS: 768,
  S: 1439,
  M: 1440,
  L: 1920,
  XL: 1920,
}
